import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { urlGetAcompanhamentoPicking } from '../../routes/dashboard.routes'

const AcompanhamentoPickingHttp = {
  async getDashboard(tpId, pInicial, pFinal) {
    try {
      const url = urlGetAcompanhamentoPicking(tpId, pInicial, pFinal)
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default AcompanhamentoPickingHttp
